/* eslint-disable import-x/no-default-export */
import type { Config } from '@ms/yammer-libs-static-config';

export default window.__yammerconfig__ as Config;
